// extracted by mini-css-extract-plugin
export default {"modal":"videoModal_modal__IXphW","modal-icon":"videoModal_modal-icon__N9CKr","modal-container":"videoModal_modal-container__oihs-"};